import { initClient, initClientNavigation } from "rwsdk/client";

const { handleResponse, onHydrated } = initClientNavigation({
  scrollBehavior: "smooth",
  scrollToTop: true,
});

initClient({ handleResponse, onHydrated });
